import { apiService } from '@/shared/services/api'
import type { APIResponse } from '@/shared/types'
import type { GamerTagResult } from '@/features/enrollment'

const mapResponseToResult = (
  gamerTag: string,
  apiResult?: Record<string, any>
): GamerTagResult => {
  if (!apiResult) {
    return {
      gamer_tag: gamerTag,
      totalHoursPlayed: 0,
      pass: false,
      error: 'No verification data returned',
      details: 'The verification service did not return any data.',
    }
  }

  const pass = Boolean(apiResult.pass ?? apiResult.exists ?? apiResult.isVerified)

  return {
    gamer_tag: apiResult.gamerTag ?? gamerTag,
    totalHoursPlayed: Number(apiResult.totalHoursPlayed ?? apiResult.hoursPlayed ?? 0),
    pass,
    error: pass ? undefined : apiResult.message ?? apiResult.error,
    details: pass ? undefined : apiResult.details,
    verifiedAt: apiResult.verifiedAt,
  }
}


export const GamerTagService = {
  async checkGamerTag(gamerTag: string, platform: string): Promise<GamerTagResult> {
    try {
      const response = await apiService.get<APIResponse<Record<string, any>>>(
        '/gamer-tags/pass-fail',
        { params: { gamerTag, console: platform } }
      )

      return mapResponseToResult(gamerTag, response.data?.data)
    } catch (error: any) {
      console.error('Error verifying gamer tag:', error)
      
      // Extract error and details from API response
      const errorResponse = error.response?.data
      const errorMessage = errorResponse?.error || 'Unable to verify gamer tag'
      const errorDetails = errorResponse?.details || 'Verification service request failed.'
      
      return {
        gamer_tag: gamerTag,
        totalHoursPlayed: 0,
        pass: false,
        error: errorMessage,
        details: errorDetails,
      }
    }
  },
}